import { z } from "zod";
import { AssignableRoleSchema } from "./assign-role.schema.js";

export const AssignUserToOrgSchema = z
  .object({
    orgId: z.string().min(1),
    role: AssignableRoleSchema,
  })
  .strict();

export type AssignUserToOrgBody = z.infer<typeof AssignUserToOrgSchema>;

export const RemoveUserFromOrgSchema = z
  .object({
    orgId: z.string().min(1),
  })
  .strict();

export type RemoveUserFromOrgBody = z.infer<typeof RemoveUserFromOrgSchema>;
